export const formatSectionName = (section: string) =>
  section?.replace(/\s/g, '-')?.toLowerCase();

export const getDocumentSection = (url: string) => {
  const splittedUrl = url.split('/');
  return splittedUrl[splittedUrl.length - 1];
};

export const getDrawId = (url: string) => {
  const str = url.match('[^draws/]?(\\d+)$');
  return str ? str[0] : undefined;
};
export const getExtensionId = (url: string) => {
  const str = url.match('[^extensions/]?(\\d+)$');
  return str ? str[0] : undefined;
};

export const getPayoffId = (url: string) => {
  const str = url.match('[^payofs/]?(\\d+)$');
  return str ? str[0] : undefined;
};

export const removeFileExtension = (filename: string) =>
  filename.replace(/\.\w+$/, '');

export const capitalize = (text: string) =>
  text
    .toLowerCase()
    .replace(/(^[a-z]| [a-z])/g, (match, letter) => letter.toUpperCase());

export const compareStrings = (strA: string, strB: string) => {
  if (strA < strB) return -1;
  if (strA > strB) return 1;
  return 0;
};

export const normalizeAmount = (amount: string): string => {
  if (amount === null || amount === undefined) return String(amount);

  const amountStr = String(amount).trim();
  const cleaned = amountStr.replace(/\$/g, "").replace(/,/g, "").trim();

  if (cleaned !== "" && !isNaN(Number(cleaned))) {
    return `$${Number(cleaned).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  }

  return amountStr;
}

// Words kept upper case by toTitleCaseIfAllCaps (acronyms used in labels)
const TITLE_CASE_ACRONYMS = new Set([
  'ACH', 'API', 'ARV', 'CRM', 'DSCR', 'FAQ', 'HOA', 'HUD', 'ID', 'LLC', 'LOI', 'LP', 'LTC', 'LTV',
  'MERS', 'PDF', 'PPP', 'QC', 'RM', 'ROC', 'SOW', 'SSN', 'TPO', 'UW', 'US', 'USA', 'W9', 'YSP',
]);
const TITLE_CASE_MINOR_WORDS = new Set(['a', 'an', 'and', 'as', 'at', 'by', 'for', 'in', 'of', 'on', 'or', 'the', 'to', 'with']);

/**
 * Converts an ALL-CAPS label ("UNDERWRITING & CLOSING") to Title Case ("Underwriting & Closing").
 * Strings that already contain lower-case letters are returned unchanged, so mixed-case labels are safe.
 */
export const toTitleCaseIfAllCaps = (text: string): string => {
  if (typeof text !== 'string' || !/[A-Z]/.test(text) || /[a-z]/.test(text)) {
    return text;
  }
  let wordIndex = 0;
  return text.replace(/[A-Z0-9][A-Z0-9'’]*/g, word => {
    const isFirst = wordIndex++ === 0;
    if (TITLE_CASE_ACRONYMS.has(word)) return word;
    const lower = word.toLowerCase();
    if (!isFirst && TITLE_CASE_MINOR_WORDS.has(lower)) return lower;
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  });
};
